/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const subscriptionAccessReasonSchema = z.enum([
	'subscribed',
	'parent-subscribed',
	'demo',
	'external-invoicing',
	'fully-serviced',
	'exempt',
	'jobilla-staff',
	'subscription-inactive',
	'no-subscription',
])

export type SubscriptionAccessReasonSchema = z.infer<typeof subscriptionAccessReasonSchema>
